<template>
  <div
    id="AppMapView"
    class="modal-card"
    :style="{width: mapWidth + 'px',height: mapHeight + 'px'}"
  >
    <div id="map" :style="{width: mapWidth + 'px',height: mapHeight + 'px'}"></div>
  </div>
</template>

<script>
export default {
  name: "AppMapView",
  props: {
    mapWidth: {
      type: Number,
      default: 900
    },
    mapHeight: {
      type: Number,
      default: 700
    },
    lat: {
      type: Number,
      default: 0
    },
    lng: {
      type: Number,
      default: 0
    },
    zoom: {
      type: Number,
      default: 10
    },
    markers: {
      type: Array
    }
  },
  methods: {
    loadMap() {
      console.log("loadMap()");
      // googleMapを初期化
      var mapDiv = document.getElementById("map");
      var baseDiv = document.getElementById("AppMapView");
      console.log("loadMap() baseDiv=" + baseDiv);
      console.log("loadMap() mapDiv=" + mapDiv);
      this.map = new google.maps.Map(mapDiv, {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
        // スワイプ判定を強めに設定(地図を移動させるには..問題)
        gestureHandling: "greedy"
      });
      this.appVue.loadingStart();
      this.addMarker(this.map);
    },
    addMarker:async function(currentMap) {
      console.log("addMarker()");
      var _this = this
      let pinErrorInfos = [];
      async function geocode_append(markerInfo){
        return new Promise(function(resolve, reject) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: markerInfo.address }, function (results, status) {
          if (status === "OK" && results.length > 0) {
            var resultInfo;
            if(results.length > 1){
              // 郵便番号がなく、ピンが特定できない場合、エラーメッセージを表示する
              if (!markerInfo.patientZipCode) {
                pinErrorInfos.push(markerInfo.name + ": " + markerInfo.address);
                resolve(status);
                return;
              }

              let maxMatchingCount = -1;
              let basePostalCode = markerInfo.patientZipCode.replace('-',''); //ピン表示する住所の郵便番号
              for( let i = 0 ; i < results.length; i++){
                let matchingCount = 0;
                let comparPostalCodeStr = {long_name:""};
                let address_components = results[i].address_components.filter(
                  function (element) {
                    if(element.types && element.types.includes("postal_code")){  //API応答オブジェクトのtypes:["postal_code"]に郵便番号が設定されて返ってくる
                      return true;
                    }
                    return false;
                  }
                );
                if(address_components && address_components.length > 0){
                  comparPostalCodeStr = address_components[0];
                }
                let comparPostalCode = comparPostalCodeStr.long_name.replace('-','');
                //郵便番号を各桁ごとに一致の判定
                if((basePostalCode[0] && comparPostalCode[0]) && (basePostalCode[0] == comparPostalCode[0])){
                  matchingCount++;
                  if((basePostalCode[1] && comparPostalCode[1]) && (basePostalCode[1] == comparPostalCode[1])){
                    matchingCount++;
                    if((basePostalCode[2] && comparPostalCode[2]) && (basePostalCode[2] == comparPostalCode[2])){
                      matchingCount++;
                      if((basePostalCode[3] && comparPostalCode[3]) && (basePostalCode[3] == comparPostalCode[3])){
                        matchingCount++;
                        if((basePostalCode[4] && comparPostalCode[4]) && (basePostalCode[4] == comparPostalCode[4])){
                          matchingCount++;
                          if((basePostalCode[5] && comparPostalCode[5]) && (basePostalCode[5] == comparPostalCode[5])){
                            matchingCount++;
                            if((basePostalCode[6] && comparPostalCode[6]) && (basePostalCode[6] == comparPostalCode[6])){
                              matchingCount++;
                            }
                          }
                        }
                      }
                    }
                  }
                }
                //郵便番号の桁数一致が多いものを検索結果として採用する
                if(matchingCount > maxMatchingCount) {
                  resultInfo = results[i];    //★ピン位置候補を設定する
                  maxMatchingCount = matchingCount;
                  }
              }
            } else {
              resultInfo = results[0];  //★GreoCoder応答が1つの場合は、そのオブジェクトをピン位置に設定する
            }
            //検索結果地が含まれるように範囲を拡大
            bounds.extend(resultInfo.geometry.location);
            // マーカーの追加
            var contentString =
              '<div id="content">' +
              '  <div id="siteNotice">' +
              markerInfo.name +
              "  </div>" +
              '  <div id="bodyContent">' +
              markerInfo.address +
              "  </div>" +
              "</div>";
            let marker = new google.maps.Marker({
              position: resultInfo.geometry.location,
              map: currentMap
            });
            // マーカーのwindow
            let infowindow = new google.maps.InfoWindow({
              content: contentString
            });
            // マーカークリック時にwindow表示
            marker.addListener("click", function() {
              infowindow.open(currentMap, marker);
            });
            // 範囲を移動
            currentMap.fitBounds(bounds);
            var level = currentMap.getZoom();
            if (level > 15) {
              currentMap.setZoom(15);
            }
            resolve(status)
          } else {
            //住所が存在しない場合の処理
            console.log("住所が正しくないか存在しません。(" + markerInfo.address + ")");
            resolve(status)
          }
        });
        });
      }
      const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      var bounds = new google.maps.LatLngBounds();
      for(var i=0; i<this.markers.length; i++){
        var challenges = 0
        var sleepTime = 0
        var rtn_Status = await geocode_append(this.markers[i]);
        while(challenges < 3 && rtn_Status=="OVER_QUERY_LIMIT"){
          challenges++;
          sleepTime = sleepTime + 1000
          await _sleep(sleepTime);
          rtn_Status = await geocode_append(this.markers[i]);
        }
      }
      this.appVue.loadingEnd();

      // ピン特定不能のエラーメッセージ表示
      if (pinErrorInfos.length > 0) {
        this.showErrorMessage("位置情報の特定に失敗しました。\n" + pinErrorInfos.join("\n"));
      }
    }
  },
  data() {
    console.log("data()");
    var appVue = this.$root.$children[0];
    return {
      map: null,
      appVue
    };
  },
  created() {
    console.log("created()");
  },
  mounted() {
    console.log("mounted()");
    var scriptjs = require("scriptjs");
    var apiKey = "AIzaSyCNxtIgO7LuDjF3aYNU2ZjP5QNr36S3dEw";
    scriptjs(
      "https://maps.googleapis.com/maps/api/js?key=" + apiKey,
      "loadGoogleMap"
    );
    scriptjs.ready("loadGoogleMap", this.loadMap);
  },
  destroyed() {
    console.log("destroyed()");
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppMapView.vue